import { AbstractControl } from '@angular/forms';
import { HtsAssistantHelper } from './hts-assistant.helper';

/**
 * #13384 F15: the assistant classifies the SAVED item description, so "Find HTS" has nothing to start without one.
 * Shared by every host of the line form (desktop sidebar / wizard / panel, OCR quick-fix, mobile line page).
 */
export class HtsAssistantDescriptionGuard {
  /** Hosts put this key FIRST in their control-errors map so its hint wins over the generic "required" one. */
  public static readonly ERROR_KEY: string = 'assistant';
  public static readonly HINT_KEY: string = 'HTS_ASSISTANT.DESCRIPTION_REQUIRED_HINT';

  /**
   * True when the description is present (whitespace does not count). Otherwise flags the control with the hint, marks
   * it touched, focuses the field on the next tick (the caller may be mid change detection) and returns false; typing
   * re-runs the validators and clears the flag.
   */
  public static require(control: AbstractControl, host: HTMLElement | null): boolean {
    if (HtsAssistantHelper.normalizeDescription(control.value)) {
      return true;
    }
    control.setErrors({ [HtsAssistantDescriptionGuard.ERROR_KEY]: true });
    control.markAsTouched();
    const field: HTMLElement | null = host ? host.querySelector('#description') : null;
    if (field) {
      setTimeout(() => field.focus());
    }
    return false;
  }
}
